import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
export const GGSTLogo = t0 => {
  const $ = _c(7);
  const {
    size: t1
  } = t0;
  const size = t1 === undefined ? 96 : t1;
  let t2;
  if ($[0] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[0] = size;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `${size}px`;
  let t4;
  if ($[2] !== t3) {
    t4 = <Image src="/GGST_WORDMARK.png" fill={true} alt="Guilty Gear Strive" className="object-contain" sizes={t3} />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t4) {
    t5 = <div style={t2} className="relative">{t4}</div>;
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};